// lib/navPref.js — preferência de NAVEGAÇÃO desktop (decisão 04/07):
// a sidebar NÃO morre — o usuário escolhe em Configurações › Perfil.
//   'ambas'   → sidebar + ilha (default do período de avaliação)
//   'sidebar' → só a sidebar clássica
//   'ilha'    → só a ilha (sidebar oculta via body.nav-sem-sidebar)
// Vale só pro shell ERP desktop; shells mobile intocados.

const KEY = 'angular-nav';

// 11/07: navegação por Ilha aposentada — a sidebar shadcn é a navegação do desktop.
export const NAVS = [
  { id: 'sidebar', label: 'Sidebar', desc: 'Menu lateral em grupos' },
];

export function currentNav() { return 'sidebar'; }

export async function applyNav() {
  try { localStorage.setItem(KEY, 'sidebar'); } catch (_) {}
  document.body.classList.remove('nav-sem-sidebar');
  try { const { unmountIlha } = await import('./ilhaNav.js'); unmountIlha(); } catch (_) {}
  return 'sidebar';
}
